"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var vf_player_config_1 = require("./interfaces/vf-player-config");
var vf_asset_loader_1 = require("./util/vf-asset-loader");
var vf_xr_manager_1 = require("./vf-xr-manager");
var vf_default_orbit_scene_builder_1 = require("./vf-default-orbit-scene-builder");
var vf_debug_helper_1 = require("./util/vf-debug-helper");
var vf_config_manager_1 = require("./util/vf-config-manager");
var const_1 = require("./util/const");
var logger_1 = require("./util/logger");
var rxjs_1 = require("rxjs");
var colors_1 = require("./util/colors");
var VFWebPlayer = (function () {
    function VFWebPlayer(canvas, config) {
        if (config === void 0) { config = {}; }
        this.canvas = canvas;
        this.beforeCompleteSceneLoadCallback = null;
        this.didCompleteSceneLoadCallback = null;
        this.didFailToLoadCallback = null;
        this.onMouseDownCallback = null;
        this.onPauseChanged = new rxjs_1.BehaviorSubject(false);
        this._isPaused = false;
        this._rotationAllowed = true;
        this._pickingEnabled = false;
        this._loadingDuration = 0.0;
        this.highlightedMeshes = new Map();
        this._loadingStartedAt = new Date();
        vf_config_manager_1.default.CreateInstance(config);
        this.config = vf_config_manager_1.default.GetConfig();
        if (this.config.enableDebug) {
            vf_config_manager_1.default.enableDebug = this.config.enableDebug;
        }
        this._screenResolution = this.getSpecificRatioLimit();
        var disableWebGl2 = !VFWebPlayer.isWebGL2Available();
        var isXrCompatible = true;
        if (!("xr" in window.navigator)) {
            isXrCompatible = false;
            logger_1.default.debug("Disabled XR Compatibility.");
        }
        this._engine = new babylonjs_1.Engine(this.canvas, true, {
            limitDeviceRatio: this._screenResolution,
            preserveDrawingBuffer: true,
            premultipliedAlpha: false,
            audioEngine: false,
            alpha: true,
            disableWebGL2Support: disableWebGl2,
            xrCompatible: isXrCompatible,
        }, true);
        logger_1.default.info("Vuframe\u00AE Aura 3D\u00AE Player v" + const_1.default.VERSION + " - WebGL" + this._engine.webGLVersion + " -  " + (vf_config_manager_1.default.enableDebug ? "DEBUG MODE" : "") + " \u2013 screen " + this._screenResolution);
        BABYLON.Database.IDBStorageEnabled = true;
        this.engine.enableOfflineSupport = true;
        this.engine.getCaps().parallelShaderCompile = null;
        this.initScene();
        this.xrManager = new vf_xr_manager_1.default(this.scene);
        this.setResizeHandler();
        this.setDebugMode();
    }
    Object.defineProperty(VFWebPlayer.prototype, "engine", {
        get: function () {
            return this._engine;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFWebPlayer.prototype, "screenResolution", {
        get: function () {
            return this._screenResolution;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFWebPlayer.prototype, "expectsAuraWebFile", {
        get: function () {
            return this.config.playerFormat === "aura";
        },
        enumerable: true,
        configurable: true
    });
    VFWebPlayer.isWebGL2Available = function () {
        try {
            var canvas = document.createElement("canvas");
            return !!(window.WebGL2RenderingContext && canvas.getContext("webgl2"));
        }
        catch (e) {
            return false;
        }
    };
    VFWebPlayer.isSafariBrowser = function () {
        return navigator.userAgent.indexOf("Safari") > -1 && !(navigator.userAgent.indexOf("Chrome") > -1);
    };
    VFWebPlayer.prototype.getSpecificRatioLimit = function () {
        if (vf_config_manager_1.default.GetConfig().screenResolution) {
            return vf_config_manager_1.default.GetConfig().screenResolution;
        }
        if (VFWebPlayer.isSafariBrowser()) {
            return const_1.default.DEVICE_RATIO_LIMIT_LOW;
        }
        if (VFWebPlayer.isWebGL2Available()) {
            return const_1.default.DEVICE_RATIO_LIMIT;
        }
        return const_1.default.DEVICE_RATIO_LIMIT;
    };
    VFWebPlayer.prototype.setDebugMode = function () {
        if (this.config.enableDebug) {
            this.debugHelper = new vf_debug_helper_1.default(this.scene);
            this.setDebugKeyListener();
        }
    };
    VFWebPlayer.prototype.startRenderLoop = function () {
        if (vf_config_manager_1.default.enableDebug) {
            this.engine.runRenderLoop(this.renderDebug.bind(this));
        }
        else {
            this.engine.runRenderLoop(this.render.bind(this));
        }
    };
    VFWebPlayer.prototype.render = function () {
        if (this.scene != null) {
            this.scene.render();
        }
    };
    VFWebPlayer.prototype.renderDebug = function () {
        try {
            if (this.scene != null) {
                this.scene.render();
            }
        }
        catch (error) {
            logger_1.default.warn(error);
        }
    };
    Object.defineProperty(VFWebPlayer.prototype, "paused", {
        get: function () {
            return this._isPaused;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFWebPlayer.prototype, "version", {
        get: function () {
            return const_1.default.VERSION;
        },
        enumerable: true,
        configurable: true
    });
    VFWebPlayer.prototype.pause = function () {
        this._isPaused = true;
        this.onPauseChanged.next(true);
        this.engine.stopRenderLoop();
    };
    VFWebPlayer.prototype.unpause = function () {
        this._isPaused = false;
        this.onPauseChanged.next(false);
        this.startRenderLoop();
    };
    Object.defineProperty(VFWebPlayer.prototype, "autorotationEnabled", {
        get: function () {
            return this.config.enableAutoRotate && this._rotationAllowed;
        },
        enumerable: true,
        configurable: true
    });
    VFWebPlayer.prototype.allowRotation = function (state) {
        this._rotationAllowed = state;
        if (state) {
            if (this.config.enableAutoRotate) {
                this.scene.startAutorotate(true);
            }
        }
        else {
            if (this.config.enableAutoRotate) {
                this.scene.stopAutorotate();
            }
        }
    };
    VFWebPlayer.prototype.toggleFullscreen = function () {
        this.engine.switchFullscreen(false);
    };
    VFWebPlayer.prototype.getFPS = function () {
        return this.engine.getFps().toFixed();
    };
    VFWebPlayer.prototype.getLoadingDuration = function () {
        return (this._loadingDuration / 1000.0).toFixed(2);
    };
    VFWebPlayer.prototype.loadModel = function (modelURL, modelMeta) {
        return __awaiter(this, void 0, void 0, function () {
            var materialsBefore, model, model;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._modelSourceUri = modelURL;
                        if (modelURL.includes("webscene.json")) {
                            if (this.config.playerFormat === "glb") {
                                logger_1.default.debug("switched to Auraweb format, because url indicates Auraweb");
                                this.config.playerFormat = "aura";
                            }
                        }
                        else if (modelURL.includes(".glb")) {
                            if (this.config.playerFormat === "aura") {
                                logger_1.default.debug("switched to GLB format, because url indicates GLB");
                                this.config.playerFormat = "glb";
                            }
                        }
                        logger_1.default.info("Player Resolution: " + this.config.playerResolution);
                        materialsBefore = Array.from(this.scene.materials);
                        if (!(this.config.playerFormat === "glb")) return [3, 2];
                        return [4, vf_asset_loader_1.default.LoadModelFromGLB(this.scene, modelURL)];
                    case 1:
                        model = _a.sent();
                        model.materials = (this.scene.materials.filter(function (material) { return !materialsBefore.includes(material); }));
                        this.scene.setModel(model, modelMeta);
                        return [2, model];
                    case 2:
                        if (!(this.config.playerFormat === "aura")) return [3, 4];
                        logger_1.default.debug(this.config);
                        return [4, vf_asset_loader_1.default.LoadModelFromAuraWeb(this.scene, modelURL, modelMeta)];
                    case 3:
                        model = _a.sent();
                        model.materials = (this.scene.materials.filter(function (material) { return !materialsBefore.includes(material); }));
                        this.scene.setModel(model, modelMeta);
                        return [2, model];
                    case 4:
                        logger_1.default.error("cannot load – unknown type (glb, webscene.json): " + modelURL);
                        return [2, null];
                }
            });
        });
    };
    VFWebPlayer.prototype.checkARAvailability = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.config.enableAR;
                        if (!_a) return [3, 2];
                        return [4, this.xrManager.isARAvailable()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2: return [2, _a];
                }
            });
        });
    };
    VFWebPlayer.prototype.enterAR = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.xrManager.enterAR()];
            });
        });
    };
    VFWebPlayer.prototype.exitEgo = function () {
        this.scene.onEgoExit();
    };
    VFWebPlayer.prototype.registerOnEgoInitCallback = function (callback) {
        this.scene.registerOnEgoInitCallback(callback);
    };
    VFWebPlayer.prototype.registerOnEgoExitCallback = function (callback) {
        this.scene.registerOnEgoExitCallback(callback);
    };
    VFWebPlayer.prototype.registerTriggerCallback = function (triggerName, callback) {
        this.scene.registerTriggerCallback(triggerName, callback);
    };
    VFWebPlayer.prototype.registerDidActivateTriggerCallback = function (callback) {
        this.scene.registerDidActivateTriggerCallback(callback);
    };
    VFWebPlayer.prototype.registerDidHoverTriggerCallback = function (callback) {
        this.scene.registerDidHoverTriggerCallback(callback);
    };
    VFWebPlayer.prototype.registerBeforeCompleteSceneLoadCallback = function (callback) {
        this.beforeCompleteSceneLoadCallback = callback;
    };
    VFWebPlayer.prototype.registerDidCompleteSceneLoadCallback = function (callback) {
        this.didCompleteSceneLoadCallback = callback;
    };
    VFWebPlayer.prototype.registerDidFailToLoadCallback = function (callback) {
        this.didFailToLoadCallback = callback;
    };
    VFWebPlayer.prototype.registerOnMouseDownCallback = function (callback) {
        this.onMouseDownCallback = callback;
    };
    VFWebPlayer.prototype.activateTrigger = function (pathOrName, byCode) {
        if (byCode === void 0) { byCode = false; }
        this.scene.activateTrigger(pathOrName, byCode);
    };
    VFWebPlayer.prototype.beforeCompleteSceneLoad = function (sceneId, format, formatVersion) {
        var elapsed = new Date().getTime() - this._loadingStartedAt.getTime();
        if (this.beforeCompleteSceneLoadCallback) {
            this.beforeCompleteSceneLoadCallback(sceneId, format, formatVersion);
        }
    };
    VFWebPlayer.prototype.didCompleteSceneLoad = function (sceneId, format, formatVersion) {
        var elapsed = new Date().getTime() - this._loadingStartedAt.getTime();
        this._loadingDuration = elapsed;
        logger_1.default.info("Scene Load Complete " + (elapsed / 1000.0).toFixed(2) + " seconds");
        if (this.didCompleteSceneLoadCallback) {
            this.didCompleteSceneLoadCallback(sceneId, format, formatVersion);
        }
    };
    VFWebPlayer.prototype.didFailToLoad = function (error) {
        if (this.didFailToLoadCallback) {
            this.didFailToLoadCallback(error);
        }
    };
    VFWebPlayer.prototype.setEgoLimits = function (startAngle, minAngle, maxAngle) {
        this.scene.egoCamera.setEgoLimits(startAngle, minAngle, maxAngle);
    };
    VFWebPlayer.prototype.setTextureForId = function (id, url, alpha) {
        if (alpha === void 0) { alpha = -1; }
        if (!this.scene) {
            logger_1.default.error("setTextureForId: scene not loaded");
        }
        this.scene.setTextureForId(id, url, alpha);
    };
    VFWebPlayer.prototype.setColorForMaterial = function (id, color) {
        if (!this.scene) {
            logger_1.default.error("setColorForMaterial: scene not loaded");
        }
        this.scene.setColorForMaterials(id, color);
    };
    VFWebPlayer.prototype.showObject = function (path) {
        if (!this.scene) {
            logger_1.default.error("showObject: scene not loaded");
        }
        this.scene.showObject(path);
    };
    VFWebPlayer.prototype.hideObject = function (path) {
        if (!this.scene) {
            logger_1.default.error("hideObject: scene not loaded");
        }
        this.scene.hideObject(path);
    };
    VFWebPlayer.prototype.dispose = function () {
        this.scene.dispose();
    };
    VFWebPlayer.prototype.initScene = function () {
        var builder = this.getBuilderForSceneType();
        builder.addCamera();
        builder.addLightSetup();
        if (this.config.enableEnvironment) {
            builder.addEnvironment(this.config.enableGroundMirror);
        }
        this.scene = builder.getScene();
        this.startRenderLoop();
        this.scene.onPointerUp = this.pickObject.bind(this);
        this.scene.onPointerDown = this.onPointerDown.bind(this);
    };
    VFWebPlayer.prototype.onPointerDown = function (evt, pickResult) {
        if (this.onMouseDownCallback) {
            this.onMouseDownCallback(evt);
        }
    };
    VFWebPlayer.prototype.pickObject = function (evt, pickResult) {
        if (vf_config_manager_1.default.enableDebug || vf_config_manager_1.default.GetConfig().enableEditor) {
            if (pickResult.hit) {
                if (this._pickingEnabled) {
                    logger_1.default.debug("Object clicked: " + pickResult.pickedMesh.name);
                    if (pickResult.pickedMesh) {
                        this.selectMesh(pickResult.pickedMesh);
                    }
                }
                else {
                    logger_1.default.debug("picking disabled");
                }
            }
            else {
                this.deselectSelectedMesh();
            }
        }
    };
    VFWebPlayer.prototype.getBuilderForSceneType = function () {
        if (this.config.sceneType === vf_player_config_1.VFSceneType.DefaultOrbitScene) {
            return new vf_default_orbit_scene_builder_1.default(this);
        }
        else {
            throw new Error("Unsupported Scene Type");
        }
    };
    VFWebPlayer.prototype.setDebugKeyListener = function () {
        var _this = this;
        this.canvas.addEventListener("keydown", function (event) {
            if (event.key === "i") {
                _this.debugHelper.toggleDebugView();
            }
        });
    };
    VFWebPlayer.prototype.setResizeHandler = function () {
        window.addEventListener("resize", function () {
            this.resize();
        }.bind(this));
    };
    VFWebPlayer.prototype.resize = function () {
        this._engine.resize();
        if (this.paused) {
            this.render();
        }
    };
    VFWebPlayer.prototype.setBackgroundColor = function (color) {
        this.scene.clearColor = colors_1.parseColorRGBA(color);
        this.canvas.style.backgroundColor = color;
        return true;
    };
    VFWebPlayer.prototype.setAmbientOcclusion = function (state) {
        if (state) {
            this.scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline("ssaopipeline", [
                this.scene.camera,
            ]);
        }
        else {
            this.scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline("ssaopipeline", [
                this.scene.camera,
            ]);
        }
    };
    VFWebPlayer.prototype.setGroundShadow = function (state) {
        this.scene.light.shadowEnabled = state;
        this.scene.shadowGenerator.recreateShadowMap();
    };
    VFWebPlayer.prototype.enableEnvironment = function (state) {
        this.scene.environment.rootMesh.setEnabled(state);
    };
    VFWebPlayer.prototype.enablePicking = function (state) {
        this._pickingEnabled = state;
    };
    VFWebPlayer.prototype.setPositioning = function (state) {
        this.scene.root.showSubMeshesBoundingBox = state;
        this.scene.root.showBoundingBox = state;
        this.enablePicking(!state);
        this.showAxis(state);
    };
    VFWebPlayer.prototype.selectMesh = function (mesh) {
        if (this.selectedMesh) {
            this.deselectMesh(this.selectedMesh);
        }
        this.selectedMesh = mesh;
        this.highlightMesh(mesh);
        mesh.showBoundingBox = true;
        mesh.showSubMeshesBoundingBox = true;
    };
    VFWebPlayer.prototype.deselectMesh = function (mesh) {
        this.unhighlightMesh(mesh);
        mesh.showBoundingBox = false;
        mesh.showSubMeshesBoundingBox = false;
        this.selectedMesh = null;
    };
    VFWebPlayer.prototype.highlightMesh = function (mesh) {
        if (!this.highlightedMeshes.has(mesh.uniqueId)) {
            this.highlightedMeshes.set(mesh.uniqueId, mesh);
        }
        mesh.renderOutline = true;
        mesh.outlineColor = babylonjs_1.Color3.Yellow();
        mesh.outlineWidth = 0.025;
        mesh.renderOverlay = true;
        mesh.overlayColor = babylonjs_1.Color3.Yellow();
        mesh.overlayAlpha = 0.05;
    };
    VFWebPlayer.prototype.unhighlightMesh = function (mesh) {
        if (this.highlightedMeshes.has(mesh.uniqueId)) {
            this.highlightedMeshes.delete(mesh.uniqueId);
        }
        mesh.renderOutline = false;
        mesh.renderOverlay = false;
    };
    VFWebPlayer.prototype.unhighlightAllMeshes = function () {
        var _this = this;
        this.highlightedMeshes.forEach(function (mesh) {
            _this.unhighlightMesh(mesh);
        });
    };
    VFWebPlayer.prototype.getMeshesByMaterialName = function (id) {
        return this.scene.getMeshesForMaterialById(id);
    };
    VFWebPlayer.prototype.deselectSelectedMesh = function () {
        if (this.selectedMesh) {
            this.deselectMesh(this.selectedMesh);
        }
    };
    VFWebPlayer.prototype.setSceneScale = function (scale) {
        this.scene.setScale(scale);
    };
    VFWebPlayer.prototype.setSceneOffset = function (x, y, z) {
        this.scene.setOffset(x, y, z);
    };
    VFWebPlayer.prototype.setSceneRotate = function (x, y, z) {
        this.scene.setRotate(x, y, z);
    };
    VFWebPlayer.prototype.setSceneFlip = function (x, y, z) {
        this.scene.setFlip(x, y, z);
    };
    VFWebPlayer.prototype.setScenePositioning = function (x, y, z) {
        this.scene.setPositioning(x, y, z);
    };
    VFWebPlayer.prototype.makeTextPlane = function (text, color, size) {
        var dynamicTexture = new babylonjs_1.DynamicTexture("DynamicTexture", 50, this.scene, true);
        dynamicTexture.hasAlpha = true;
        dynamicTexture.drawText(text, 5, 40, "bold 36px Arial", color, "transparent", true);
        var plane = babylonjs_1.Mesh.CreatePlane("TextPlane", size, this.scene, true);
        var material = new babylonjs_1.StandardMaterial("TextPlaneMaterial", this.scene);
        material.backFaceCulling = false;
        material.specularColor = new babylonjs_1.Color3(0, 0, 0);
        material.diffuseTexture = dynamicTexture;
        plane.material = material;
        plane.isPickable = false;
        return plane;
    };
    VFWebPlayer.prototype.showAxis = function (state) {
        if (!this.worldAxis) {
            this.createAxis(1);
        }
        this.worldAxis.setEnabled(state);
    };
    VFWebPlayer.prototype.createAxis = function (size) {
        var axisObject = new babylonjs_1.TransformNode("axis", this.scene);
        var axisX = babylonjs_1.Mesh.CreateLines("axisX", [
            babylonjs_1.Vector3.Zero(),
            new babylonjs_1.Vector3(size, 0, 0),
            new babylonjs_1.Vector3(size * 0.95, 0.05 * size, 0),
            new babylonjs_1.Vector3(size, 0, 0),
            new babylonjs_1.Vector3(size * 0.95, -0.05 * size, 0),
        ], this.scene);
        axisX.color = new babylonjs_1.Color3(1, 0, 0);
        axisX.parent = axisObject;
        axisX.isPickable = false;
        var xChar = this.makeTextPlane("X", "red", size / 10);
        xChar.name = "labelX";
        xChar.position = new babylonjs_1.Vector3(0.9 * size, -0.05 * size, 0);
        xChar.parent = axisObject;
        var axisY = babylonjs_1.Mesh.CreateLines("axisY", [
            babylonjs_1.Vector3.Zero(),
            new babylonjs_1.Vector3(0, size, 0),
            new babylonjs_1.Vector3(-0.05 * size, size * 0.95, 0),
            new babylonjs_1.Vector3(0, size, 0),
            new babylonjs_1.Vector3(0.05 * size, size * 0.95, 0),
        ], this.scene);
        axisY.color = new babylonjs_1.Color3(0, 1, 0);
        axisY.parent = axisObject;
        axisY.isPickable = false;
        var yChar = this.makeTextPlane("Y", "green", size / 10);
        xChar.name = "labelY";
        yChar.position = new babylonjs_1.Vector3(0, 0.9 * size, -0.05 * size);
        yChar.parent = axisObject;
        var axisZ = babylonjs_1.Mesh.CreateLines("axisZ", [
            babylonjs_1.Vector3.Zero(),
            new babylonjs_1.Vector3(0, 0, size),
            new babylonjs_1.Vector3(0, -0.05 * size, size * 0.95),
            new babylonjs_1.Vector3(0, 0, size),
            new babylonjs_1.Vector3(0, 0.05 * size, size * 0.95),
        ], this.scene);
        axisZ.color = new babylonjs_1.Color3(0, 0, 1);
        axisZ.parent = axisObject;
        axisZ.isPickable = false;
        var zChar = this.makeTextPlane("Z", "blue", size / 10);
        xChar.name = "labelZ";
        zChar.position = new babylonjs_1.Vector3(0, 0.05 * size, 0.9 * size);
        zChar.parent = axisObject;
        this.worldAxis = axisObject;
    };
    return VFWebPlayer;
}());
exports.default = VFWebPlayer;
